module.exports = __webpack_public_path__ + "media/images/info-check-ddcef97f38f26e47b111d43aa039aba6.svg";